<div class="join-class-container">
  <button class="close-button" (click)="closePostDialog()">
    <mat-icon>close</mat-icon>
  </button>
  <h2 class="create-account">Join Classroom</h2>
  <p class="subtext">
    {{
      userRole === Roles.TEACHER
        ? "Enter the class code you received to join as a co-teacher and start collaborating."
        : "Enter the class code you received to join as a student."
    }}
  </p>
  <form [formGroup]="joinClassCodeForm">
    <div class="mb-4">
      <label for="classroomCode" class="form-label">Classroom Code</label>
      <input type="text" formControlName="class_code" id="classroomCode"
        class="form-control input-field" placeholder="Enter the code you received"
      />
      <div
        *ngIf=" joinClassCodeForm.get('class_code')?.invalid && joinClassCodeForm.get('class_code')?.touched" class="text-danger">
        <small *ngIf="joinClassCodeForm.get('class_code')?.errors?.['required']"
          >Classroom code is required.</small
        >
        <small *ngIf="joinClassCodeForm.get('class_code')?.errors?.['pattern']"
          >Code must be 8 characters (letters and numbers only).</small
        >
      </div>
    </div>
    <button
      type="submit"
      class="btn join-btn w-100"
      [disabled]="joinClassCodeForm.invalid || isLoading"
      (click)="joinClassroom()">
	  <ng-container *ngIf="!isLoading;else noLoading">Join Class</ng-container>
	  <ng-template #noLoading>
		<span class="spinner-text">
		<mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>Joining...</span>
	  </ng-template>
    </button>
  </form>
</div>